import * as v from 'valibot';
function domainString() {
    return v.pipe(v.string(), v.transform((value) => value));
}
export function pii(purpose) {
    void purpose;
    return domainString();
}
export function secret(purpose) {
    void purpose;
    return domainString();
}
export function identifier(purpose) {
    void purpose;
    return domainString();
}
//# sourceMappingURL=domain-string.js.map